import {Regions} from "./../model/Region"
import {UniversityBranches} from "./../model/UniversityBranch"
import {Divisions} from "../model/Division"

import {composeSheetData, SheetData} from "./../Excel/export"
import {lpad, composeRow, RowData, getCompany, getRegion, getUniversityBranch} from "./../model/utils/utils"
import {User} from "../model/User";
import RowStyle = XlsxStyle.RowStyle;
import {Finance, spendingTypeTitle} from "../model/Finance";
import {FINANCE_YEARS} from "./common";

enum Rows {
    Title1 = 0,
    Title2,
    Company,
    Date,
    Person,
    Blank,
    Heading1,
    Heading2,
    Heading3,
}

enum Columns {
    id = 0,
    division,
    company,
    companyRegion,
    companyCity,
    universityAbbreviation,
    universityTitle,
    universityType,
    region,
    district,
    spendingType,
    yearFinal,
    yearForecast,
    cooperationSubject,
}

const makeEmptyRow = <D = RowData>(data: D = {} as D): D => ({
    [Columns.id]: null,
    [Columns.division]: null,
    [Columns.company]: null,
    [Columns.companyRegion]: null,
    [Columns.companyCity]: null,
    [Columns.universityAbbreviation]: null,
    [Columns.universityTitle]: null,
    [Columns.universityType]: null,
    [Columns.region]: null,
    [Columns.district]: null,
    [Columns.spendingType]: null,
    [Columns.yearFinal]: null,
    [Columns.yearForecast]: null,
    [Columns.cooperationSubject]: null,
    ...data,
})

const merges = [
    [Columns.id, Rows.Title1, Columns.district, Rows.Title1],
    [Columns.id, Rows.Title2, Columns.district, Rows.Title2],
    [Columns.id, Rows.Company, Columns.division, Rows.Company],
    [Columns.id, Rows.Date, Columns.division, Rows.Date],
    [Columns.id, Rows.Person, Columns.division, Rows.Person],
    [Columns.id,                 Rows.Heading1, Columns.id,                 Rows.Heading3],
    [Columns.division,           Rows.Heading1, Columns.division,           Rows.Heading3],
    [Columns.company,            Rows.Heading1, Columns.company,            Rows.Heading3],
    [Columns.companyRegion,      Rows.Heading1, Columns.companyRegion,      Rows.Heading3],
    [Columns.companyCity,        Rows.Heading1, Columns.companyCity,        Rows.Heading3],
    [Columns.universityAbbreviation, Rows.Heading1, Columns.universityType, Rows.Heading2],
    [Columns.region,   Rows.Heading1, Columns.region,   Rows.Heading3],
    [Columns.district, Rows.Heading1, Columns.district, Rows.Heading3],
    [Columns.spendingType, Rows.Heading1, Columns.spendingType, Rows.Heading3],
    [Columns.yearFinal, Rows.Heading1, Columns.yearForecast, Rows.Heading2],
    [Columns.cooperationSubject, Rows.Heading1, Columns.cooperationSubject, Rows.Heading3],
]

let widths = makeEmptyRow({
    [Columns.id]: 6.5,
    [Columns.division]: 10.83,
    [Columns.company]: 24.83,
    [Columns.companyRegion]: 24.83,
    [Columns.companyCity]: 24.83,
    [Columns.universityAbbreviation]: 17.5,
    [Columns.universityTitle]: 19,
    [Columns.universityType]: 19,
    [Columns.region]: 19,
    [Columns.district]: 18.5,
    [Columns.spendingType]: 25,
    [Columns.yearFinal]: 20,
    [Columns.yearForecast]: 20,
    [Columns.cooperationSubject]: 25,
})


const border = {
    top:    {style: "thin", color: {auto: 1}},
    left:   {style: "thin", color: {auto: 1}},
    right:  {style: "thin", color: {auto: 1}},
    bottom: {style: "thin", color: {auto: 1}},
}

const title1Row = (): RowData => makeEmptyRow({
    [Columns.id]: {s: {font: {bold: true}, alignment: {horizontal: "center", vertical: "center"}}, v: "Данные о расходовании средств, затрачиваемых на взаимодействие с образовательнымие организациямии"}
})

const title2Row = (): RowData => makeEmptyRow({
    [Columns.id]: {s: {font: {bold: true}, alignment: {horizontal: "center", vertical: "center"}}, v: "организацией Госкорпорации «Росатом»"}
})

const companyRow = (v: string): RowData => makeEmptyRow({
    [Columns.id]: {s: {font: {bold: true}, alignment: {horizontal: "right",  vertical: "top"}},    v: "Организация:"},
    [Columns.company]: {s: {font: {bold: false}, alignment: {vertical: "center"}}, v},
})

const dateRow = makeEmptyRow({
    [Columns.id]: {s: {font: {bold: true}, alignment: {horizontal: "right",  vertical: "center"}}, v: "Дата заполнения:"},
    [Columns.company]: {s: {font: {bold: false}, alignment: {vertical: "center"}}, v: new Date()},
})

const personRow = (v: string): RowData => makeEmptyRow({
//    [Columns.id]: {s: {font: {bold: true}, alignment: {horizontal: "right",  vertical: "center"}}, v: "Ответственный:"},
    [Columns.company]: {s: {font: {bold: false}, alignment: {vertical: "center"}}, v},
})

let blankRow = makeEmptyRow()
let heading1Row = makeEmptyRow()
let heading2Row = makeEmptyRow()
let heading3Row = makeEmptyRow()

heading1Row[Columns.id]                     = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Код"}
heading1Row[Columns.division]               = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Дивизион"}
heading1Row[Columns.company]                = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Предприятие"}
heading1Row[Columns.companyRegion]          = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Регион"}
heading1Row[Columns.companyCity]            = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Город"}
heading1Row[Columns.universityAbbreviation] = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "bottom", vertical: "bottom"}}, v: "Образовательная организация"}
heading1Row[Columns.universityTitle]        = {s: {border}}
heading1Row[Columns.universityType]         = {s: {border}}
heading1Row[Columns.region]                 = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Регион"}
heading1Row[Columns.district]               = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Округ"}
heading1Row[Columns.spendingType]           = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Направление расходования средств"}
heading1Row[Columns.yearFinal]          = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "bottom", vertical: "bottom"}}, v: "Сумма финансирования"}
heading1Row[Columns.yearForecast]       = {s: {border}}
heading1Row[Columns.cooperationSubject]     = {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Предмет сотрудничества с образовательной организацией"}

heading2Row[Columns.id]                     = {s: {border}}
heading2Row[Columns.division]               = {s: {border}}
heading2Row[Columns.company]                = {s: {border}}
heading2Row[Columns.companyRegion]          = {s: {border}}
heading2Row[Columns.companyCity]            = {s: {border}}
heading2Row[Columns.universityAbbreviation] = {s: {border}}
heading2Row[Columns.universityTitle]        = {s: {border}}
heading2Row[Columns.universityType]         = {s: {border}}
heading2Row[Columns.region]                 = {s: {border}}
heading2Row[Columns.district]               = {s: {border}}
heading2Row[Columns.spendingType]           = {s: {border}}
heading2Row[Columns.cooperationSubject]     = {s: {border}}

heading3Row[Columns.id]                     = {s: {border}}
heading3Row[Columns.division]               = {s: {border}}
heading3Row[Columns.company]                = {s: {border}}
heading3Row[Columns.companyRegion]          = {s: {border}}
heading3Row[Columns.companyCity]            = {s: {border}}
heading3Row[Columns.universityAbbreviation] = {s: {border, font: {bold: true}, alignment: {wrapText: true,  horizontal: "left",   vertical: "center"}}, v: "Аббревиатура"}
heading3Row[Columns.universityTitle]        = {s: {border, font: {bold: true}, alignment: {wrapText: true,  horizontal: "center", vertical: "center"}}, v: "Название"}
heading3Row[Columns.universityType]         = {s: {border, font: {bold: true}, alignment: {wrapText: true,  horizontal: "center", vertical: "center"}}, v: "Тип"}
heading3Row[Columns.region]                 = {s: {border}}
heading3Row[Columns.district]               = {s: {border}}
heading3Row[Columns.spendingType]           = {s: {border}}
heading3Row[Columns.yearFinal]          = {s: {border, font: {bold: true}, alignment: {wrapText: true,  horizontal: "left",   vertical: "center"}}, v: FINANCE_YEARS[0] + " г., факт"}
heading3Row[Columns.yearForecast]       = {s: {border, font: {bold: true}, alignment: {wrapText: true,  horizontal: "left",   vertical: "center"}}, v: FINANCE_YEARS[1] + " г., план"}
heading3Row[Columns.cooperationSubject]     = {s: {border}}


const footer = (data: RowData[]): RowData => ({
    [Columns.id]: "",
    [Columns.division]: "",
    [Columns.company]: "",
    [Columns.companyRegion]: "",
    [Columns.companyCity]: "",
    [Columns.universityAbbreviation]: "",
    [Columns.universityTitle]: "",
    [Columns.universityType]: "",
    [Columns.region]: "",
    [Columns.district]: "Итого",
    [Columns.spendingType]: "",
    [Columns.yearFinal]: {
        s: {font: {bold: true}, numFmt: "#,##0.00\\ [$₽-419]"},
        f: data.length ? 'SUBTOTAL(9,INDIRECT("R[-' + (data.length) + ']C[0]:R[-1]C[0]",0))' : '0',
        t: "n",
    },
    [Columns.yearForecast]: {
        s: {font: {bold: true}, numFmt: "#,##0.00\\ [$₽-419]"},
        f: data.length ? 'SUBTOTAL(9,INDIRECT("R[-' + (data.length) + ']C[0]:R[-1]C[0]",0))' : '0',
        t: "n",
    },
    [Columns.cooperationSubject]: "",
})

type Data = {
    finances: Finance[]
    divisions: Divisions
    regions: Regions
    universityBranches: UniversityBranches
    meta: {
        company: string
        user: User
    }
}

const composeData = ({
    finances,
    divisions,
    regions,
    universityBranches,
}: Data): RowData[] => {
    let rawResult: RowData[] = []

    finances.map(({
        id,
        companyId,
        universityBranchId,
        spendingType,
        cooperationSubject,
        yearFinal,
        yearForecast,
    }: Finance) => {
        const {
            division,
            company,
            region,
            city,
        } = getCompany(divisions, companyId)

        const {
            abbreviation: universityAbbreviation,
            title: universityTitle,
            type: universityType,
            regionId,
        } = getUniversityBranch(universityBranches, universityBranchId)

        const {
            name: regionName,
            district: regionDistrict,
        } = getRegion(regions, regionId)

        const row = makeEmptyRow({
            [Columns.id]: lpad(id),
            [Columns.division]: division,
            [Columns.company]: company,
            [Columns.companyRegion]: region,
            [Columns.companyCity]: city,
            [Columns.universityAbbreviation]: universityAbbreviation,
            [Columns.universityTitle]: universityTitle,
            [Columns.universityType]: universityType,
            [Columns.region]: regionName,
            [Columns.district]: regionDistrict,
            [Columns.spendingType]: spendingTypeTitle[spendingType],
            [Columns.yearFinal]: {
                s: {numFmt: "#,##0.00\\ [$₽-419]"},
                v: yearFinal,
                t: "n" as "n",
            },
            [Columns.yearForecast]: {
                s: {numFmt: "#,##0.00\\ [$₽-419]"},
                v: yearForecast,
                t: "n" as "n",
            },
            [Columns.cooperationSubject]: cooperationSubject,
        })

        rawResult = rawResult.concat([row])
    })

    return rawResult
}

export const financesWs = (data: Data): SheetData => {
    console.time(__filename)

    const sheetData = composeData(data)

    const sheetFooter = footer(sheetData)
    const title = "Финансирование вузов"

    let sheet = composeSheetData(composeRow(title1Row())
        .concat(composeRow(title2Row()))
        .concat(composeRow(companyRow(data.meta.company)))
        .concat(composeRow(dateRow))
        .concat(composeRow(personRow(data.meta.user.executor.fullName)))
        .concat(composeRow(blankRow))
        .concat(composeRow(heading1Row))
        .concat(composeRow(heading2Row))
        .concat(composeRow(heading3Row))
        .concat(sheetData.map(a => Object.keys(a).map(b => a[b])))
        .concat(composeRow(sheetFooter))
    )

    sheet["!merges"] = merges.map(m => ({
        s: {c: m[0], r: m[1]},
        e: {c: m[2], r: m[3]},
    }))

    sheet["!cols"] = Object.keys(widths).map(column => ({wch: widths[column]}))

    let rows: RowStyle[] = []
    rows[Rows.Heading3] = {hpt: 31}

    sheet["!rows"] = rows

    console.timeEnd(__filename)

    return {
        sheet,
        title,
        filter: {
            columns: Object.keys(sheetFooter).length,
            row: Rows.Heading3,
        },
    }
}
